<template>
  <b-card :class="['card-challenges-ranking', color]" no-body header-tag="header" footer-tag="footer">
    <template v-slot:header class="d-flex">
      <span class="badge">
        <font-awesome-icon :icon="[icon.type, icon.name]" />
      </span>
          <h2 class="title">
            <PuSkeleton :loading="isLoading" :count="1" width='120px'>                        
              {{title}}
            </PuSkeleton>
          </h2>
    </template>
    <b-card-text>
      <b-list-group>

      <b-list-group-item v-for="(list,index) in lists" :key="index">
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height="20px">                        
            <p class="increase">{{list.increase}}</p>
            <p class="number">{{list.ranking}}</p>
            <p class="fullname">{{list.fullname}}</p>
            <p class="result">{{list.result}}</p>
          </PuSkeleton>
        </b-list-group-item>
      </b-list-group>
    </b-card-text>
  </b-card>

</template>


<script>
import Utils from '../../Utils'
//
export default {
  name: "CardChallengesRanking",
  components:{ 
  },
  props:{
    color:{
      type:String,
      default:'blue'
    },
    title:{
      type:String,
      default:'Top semaine'
    },
    icon :{
      type:Object,
      default () {
        return {
          type :'fas',
          name :'trophy-alt'
        }
      } 
    },
    lists:{
      type:Array,
      default:() => [
          {
            increase : '+1',
            ranking : '6',
            fullname : 'KUCUKTAS VOLKAN',
            result : '271,00'
          },
          {
            increase : '-1',
            ranking : '6',
            fullname : 'KUCUKTAS VOLKAN',
            result : '271,00'
          },
          {
            increase : '+1',
            ranking : '6',
            fullname : 'KUCUKTAS VOLKAN',
            result : '271,00'
          }
        ]
    }
  },
  data(){
    return {    
        isLoading:true,
    }
  },
  methods : {
  },  
  mounted (){
    const targets = this.$el.querySelectorAll('.increase');
    targets.forEach(element => {
      if(Utils.getFirstLetter(element.innerHTML) == true){
        element.classList.add('negatif');
      } else if(Utils.getFirstLetter(element.innerHTML) == false){
        element.classList.add('positif');
      }
    });
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }  
}
</script>